/**
 * DeleteButton component for confirming deletion actions.
 * @param onConfirm - Callback function to execute on confirmation.
 * @param label - Confirmation message to display in the dialog.
 * @returns The DeleteButton component.
 */

import * as Dialog from '@radix-ui/react-dialog';
import React, { useState } from 'react';
import SecondaryButton from '../SecondaryButton/SecondaryButton';
import GenericButton from '../GenericButton/GenericButton';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const DeleteButton: React.FC<{
	label?: string;
	size?: 'sm' | 'md' | 'lg';
	onConfirm: () => void;
	question: string;
	icon?: IconProp;
	invert?: boolean;
	hideIcon?: boolean;
}> = ({
	label = 'Supprimer',
	onConfirm,
	question,
	size = 'md',
	icon,
	invert = false,
	hideIcon = false,
}) => {
	// State to manage the visibility of the dialog
	const [open, setOpen] = useState(false);

	return (
		<Dialog.Root open={open} onOpenChange={setOpen}>
			<Dialog.Trigger asChild>
				<Dialog.Trigger asChild>
					<GenericButton
						variant="delete"
						label={label}
						size={size}
						icon={icon}
						invert={invert}
						hideIcon={hideIcon}
					/>
				</Dialog.Trigger>
			</Dialog.Trigger>
			<Dialog.Portal>
				<Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30" />
				<Dialog.Content className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-6 shadow-lg w-80">
					<Dialog.Title className="text-lg font-bold mb-4">
						Confirmation
					</Dialog.Title>
					<Dialog.Description className="mb-6">{question}</Dialog.Description>
					<div className="flex justify-end space-x-2">
						<Dialog.Close asChild>
							<SecondaryButton
								onClick={() => setOpen(false)}
								label="Annuler"
								size="lg"
							/>
						</Dialog.Close>
						<GenericButton
							variant="delete"
							size="lg"
							label="Supprimer"
							onClick={() => {
								onConfirm();
								setOpen(false);
							}}
						/>
					</div>
				</Dialog.Content>
			</Dialog.Portal>
		</Dialog.Root>
	);
};

// Export the DeleteButton component as the default export
export default DeleteButton;
